import React from 'react';

class FormatoSimplificado536888PlanPremium_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 536888 Plan Premium';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1345223_R_PREMIUM_2022_V1.pdf?alt=media&token=34661f2a-74eb-471d-bdec-f0aff77f16b0';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado536888PlanPremium_pdf